import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SChangePasswordInput = styled.div`
  margin-bottom: 12px;

  ${setFlexDFFDC};
`;
